import { 
    POST_LIKE_PROCESS_LOADING, 
    POST_LIKE_UPDATED,
    POST_LIKE_PROCESS_FAILED,
    POST_LIKE_LOADED,

    POST_COMMENT_PROCESS_LOADING,
    POST_COMMENT_LOADED,
    POST_COMMENT_PROCESS_FAILED
} from '../actions/post';
  

const initialState = {
    isLoading: false,
    likesList: [],
    isLiked: '',
    commentList: [],
    errors: null,
    new: {
        isLoading: false,
        isSuccess: false,
        errors: null
    }
}

const postReducer = (state = initialState, action) => {
    switch (action.type) {
       
        case POST_LIKE_PROCESS_LOADING:
            return {
                ...state,
                new: {
                    isLoading: true,
                    isSuccess: false,
                    errors: null
                }
            }
        case POST_LIKE_PROCESS_FAILED:
            return {
                ...state,
                new: {
                    isLoading: false,
                    isSuccess: false,
                    errors: action.errors
                }
            }
        case POST_LIKE_LOADED:
            return {
                ...state,
                isLoading: false,
                likesList: action.data.likesList,
                errors: null
            }
        
        case POST_LIKE_UPDATED:
            return {
                ...state,
                // isLiked: action.data.isLiked,
                new: {
                    isLoading: false,
                    isSuccess: true,
                    errors: null
                }
            }
        case POST_COMMENT_PROCESS_LOADING:
            return {
                ...state,
                new: {
                    isLoading: true,
                    isSuccess: false,
                    errors: null
                }
            }
        case POST_COMMENT_PROCESS_FAILED:
            return {
                ...state,
                new: {
                    isLoading: false,
                    isSuccess: false,
                    errors: action.errors
                }
            }
        case POST_COMMENT_LOADED:
            return {
                ...state,
                isLoading: false,
                commentList: action.data.commentList,
                errors: null
            }
        default:
            return state;
    }
};
  
export default postReducer;
  